import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_2 = { class: "mb-6 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "p-2 bg-[#22282F]/10 rounded-lg" }
const _hoisted_5 = {
  key: 0,
  class: "py-16 text-center text-gray-400"
}
const _hoisted_6 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-4 my-6" }
const _hoisted_7 = { class: "bg-white rounded-xl border border-gray-200 p-5" }
const _hoisted_8 = { class: "text-3xl font-bold text-[#1d2a5e]" }
const _hoisted_9 = { class: "bg-white rounded-xl border border-gray-200 p-5" }
const _hoisted_10 = { class: "text-3xl font-bold text-emerald-600" }
const _hoisted_11 = { class: "bg-white rounded-xl border border-gray-200 p-5" }
const _hoisted_12 = { class: "text-3xl font-bold text-gray-700" }
const _hoisted_13 = { class: "bg-white rounded-xl border border-gray-200 p-5 mb-6" }
const _hoisted_14 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_15 = { class: "w-52 flex items-center gap-2" }
const _hoisted_16 = { class: "text-[10px] font-mono px-1.5 py-0.5 rounded bg-gray-100 text-gray-500" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "flex-1 bg-gray-100 rounded-full h-5 overflow-hidden" }
const _hoisted_19 = { class: "w-12 text-right text-sm font-bold text-[#1d2a5e]" }
const _hoisted_20 = {
  key: 1,
  class: "text-sm text-gray-400"
}
const _hoisted_21 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6" }
const _hoisted_22 = { class: "bg-white rounded-xl border border-gray-200 p-5 mb-6" }
const _hoisted_23 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_24 = ["title"]
const _hoisted_25 = { class: "flex-1 bg-gray-100 rounded-full h-5 overflow-hidden" }
const _hoisted_26 = { class: "w-12 text-right text-sm font-bold text-[#1d2a5e]" }
const _hoisted_27 = ["title"]
const _hoisted_28 = {
  key: 1,
  class: "text-sm text-gray-400"
}
const _hoisted_29 = { class: "bg-white rounded-xl border border-gray-200 overflow-hidden" }
const _hoisted_30 = { class: "px-5 py-4 border-b border-gray-100 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" }
const _hoisted_31 = { class: "flex items-center gap-2" }
const _hoisted_32 = { class: "relative" }
const _hoisted_33 = { class: "text-xs text-gray-400 whitespace-nowrap" }
const _hoisted_34 = { class: "overflow-x-auto" }
const _hoisted_35 = { class: "min-w-full text-sm" }
const _hoisted_36 = { class: "px-4 py-2 align-top" }
const _hoisted_37 = { class: "font-medium text-gray-800" }
const _hoisted_38 = ["title"]
const _hoisted_39 = { class: "px-4 py-2 align-top" }
const _hoisted_40 = { class: "px-4 py-2 align-top text-gray-500" }
const _hoisted_41 = { class: "px-4 py-2 align-top" }
const _hoisted_42 = { class: "px-4 py-2 align-top" }
const _hoisted_43 = { class: "flex items-start gap-2 max-w-[320px]" }
const _hoisted_44 = { class: "min-w-0" }
const _hoisted_45 = { class: "text-gray-700" }
const _hoisted_46 = ["title"]
const _hoisted_47 = { key: 0 }
const _hoisted_48 = {
  key: 0,
  class: "px-5 py-3 border-t border-gray-100 flex items-center justify-between text-sm"
}
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "text-gray-500" }
const _hoisted_51 = ["disabled"]

import { ref, computed, watch, onMounted, h } from 'vue'
import { MapPin, Search } from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import StatsFilterBar from '@/components/dashboard/StatsFilterBar.vue'
import { apiFetch } from '@/utils/apiFetch'
import { useToast } from '@/utils/toast'

const PAGE_SIZE = 20


export default /*@__PURE__*/_defineComponent({
  __name: 'SuiviCourriersView',
  setup(__props) {

const toast = useToast()
const loading = ref(false)
const data = ref<any>(null)
const filters = ref<Record<string, string>>({})

const search = ref('')
const page = ref(1)
const maxRole = computed(() =>
  Math.max(1, ...((data.value?.par_role || []).map((r: any) => r.count))))
const maxNiveau = computed(() =>
  Math.max(1, ...((data.value?.par_niveau || []).map((n: any) => n.count))))

function barWidth(v: number, max: number) {
  return `${Math.max(4, Math.round((v / max) * 100))}%`
}

// ── Couleurs par étape (statut normalisé) ───────────────────────────
function stageKey(s: string) {
  const k = (s || '').toLowerCase()
  if (k.includes('attente')) return 'attente'
  if (k.includes('redaction') || k.includes('rdaction')) return 'redaction'
  if (k.includes('traitement')) return 'traitement'
  if (k.includes('consultation')) return 'consultation'
  if (k.includes('accepte')) return 'accepte'
  return 'autre'
}
const PILL: Record<string, string> = {
  attente: 'bg-amber-100 text-amber-700',
  redaction: 'bg-blue-100 text-blue-700',
  traitement: 'bg-indigo-100 text-indigo-700',
  consultation: 'bg-purple-100 text-purple-700',
  accepte: 'bg-teal-100 text-teal-700',
  autre: 'bg-gray-100 text-gray-600',
}
const DOT: Record<string, string> = {
  attente: 'bg-amber-400',
  redaction: 'bg-blue-500',
  traitement: 'bg-indigo-500',
  consultation: 'bg-purple-500',
  accepte: 'bg-teal-500',
  autre: 'bg-gray-400',
}
const BAR: Record<string, string> = {
  attente: 'bg-amber-400',
  redaction: 'bg-blue-500',
  traitement: 'bg-indigo-500',
  consultation: 'bg-purple-500',
  accepte: 'bg-teal-500',
  autre: 'bg-[#1d2a5e]',
}
const stagePillClass = (s: string) => PILL[stageKey(s)]
const stageDotClass = (s: string) => DOT[stageKey(s)]
const stageBarClass = (s: string) => BAR[stageKey(s)]

function agingClass(days: number | null) {
  if (days == null) return 'text-gray-400'
  if (days >= 7) return 'text-red-600 font-semibold'
  if (days >= 3) return 'text-amber-600'
  return 'text-gray-500'
}

// ── Recherche + pagination (côté client) ────────────────────────────
const filteredDetail = computed(() => {
  const rows = data.value?.detail || []
  const q = search.value.trim().toLowerCase()
  if (!q) return rows
  return rows.filter((r: any) =>
    [`#${r.courrier_id}`, r.courrier_id, r.objet, r.detenteur, r.direction,
     r.ambassade, r.etape, r.motif, r.commentaire]
      .filter(Boolean)
      .some((v: any) => String(v).toLowerCase().includes(q)))
})
const totalPages = computed(() => Math.max(1, Math.ceil(filteredDetail.value.length / PAGE_SIZE)))
const pageRows = computed(() => filteredDetail.value.slice((page.value - 1) * PAGE_SIZE, page.value * PAGE_SIZE))

watch([search, filteredDetail], () => { if (page.value > totalPages.value) page.value = 1 })

function queryString() {
  const p = new URLSearchParams()
  Object.entries(filters.value).forEach(([k, v]) => { if (v) p.append(k, v) })
  const s = p.toString()
  return s ? `?${s}` : ''
}

async function fetchData() {
  loading.value = true
  try {
    data.value = await apiFetch(`/api/admin/stats/positions/${queryString()}`)
    page.value = 1
  } catch (e: any) {
    toast.error('Erreur', e.message || 'Chargement impossible')
  } finally {
    loading.value = false
  }
}

function onFilterChange(params: Record<string, string>) {
  filters.value = params || {}
  fetchData()
}

onMounted(fetchData)

// Petit tableau de dimension (département / direction / ambassade).
const DimTable = (props: any) => {
  const rows = props.rows || []
  return h('div', { class: 'bg-white rounded-xl border border-gray-200 p-5' }, [
    h('h2', { class: 'font-semibold text-gray-800 mb-3' }, props.title),
    rows.length
      ? h('table', { class: 'min-w-full text-sm' }, [
          h('tbody', rows.map((r: any) =>
            h('tr', { class: 'border-t border-gray-100' }, [
              h('td', { class: 'py-2 pr-2 text-gray-700' }, r.label || '-'),
              h('td', { class: 'py-2 pl-2 text-right font-bold text-[#1d2a5e]' }, r.count),
            ])))
        ])
      : h('p', { class: 'text-sm text-gray-400' }, 'Aucune donnée.'),
  ])
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(MapPin), { class: "w-7 h-7 text-[#22282F]" })
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", null, [
              _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-gray-900" }, "Suivi des courriers"),
              _createElementVNode("p", { class: "text-sm text-gray-500" }, "Où se trouvent les courriers : chez qui, à quel niveau et pourquoi.")
            ], -1))
          ]),
          _createElementVNode("button", {
            onClick: fetchData,
            class: "px-4 py-2 bg-[#22282F] text-white rounded-lg text-sm hover:opacity-90"
          }, " Actualiser ")
        ]),
        _createVNode(StatsFilterBar, { onChange: onFilterChange }),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Chargement…"))
          : (data.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-xs uppercase tracking-wide text-gray-500" }, "En cours", -1)),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(data.value.resume.en_cours), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs uppercase tracking-wide text-gray-500" }, "Finalisés", -1)),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(data.value.resume.finalises), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-xs uppercase tracking-wide text-gray-500" }, "Courriers suivis", -1)),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(data.value.resume.total_suivis), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "font-semibold text-gray-800 mb-1" }, "Répartition par rôle", -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-xs text-gray-400 mb-4" }, "Du plus haut niveau hiérarchique au plus bas.", -1)),
                  ((data.value.par_role || []).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.par_role, (r) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: r.role_code || r.role,
                            class: "flex items-center gap-3"
                          }, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("span", _hoisted_16, "N" + _toDisplayString(r.niveau ?? '?'), 1),
                              _createElementVNode("span", {
                                class: "text-sm text-gray-700 truncate",
                                title: r.role
                              }, _toDisplayString(r.role), 9, _hoisted_17)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", {
                                class: "h-5 bg-[#1d2a5e] rounded-full",
                                style: _normalizeStyle({ width: barWidth(r.count, maxRole.value) })
                              }, null, 4)
                            ]),
                            _createElementVNode("div", _hoisted_19, _toDisplayString(r.count), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_20, "Aucun courrier en cours sur ce périmètre."))
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(DimTable, {
                    title: "Par département",
                    rows: data.value.par_departement
                  }, null, 8, ["rows"]),
                  _createVNode(DimTable, {
                    title: "Par direction",
                    rows: data.value.par_direction
                  }, null, 8, ["rows"]),
                  _createVNode(DimTable, {
                    title: "Par ambassade",
                    rows: data.value.par_ambassade
                  }, null, 8, ["rows"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "font-semibold text-gray-800 mb-4" }, "Répartition par étape", -1)),
                  ((data.value.par_niveau || []).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.par_niveau, (n) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: n.label,
                            class: "flex items-center gap-3"
                          }, [
                            _createElementVNode("div", {
                              class: "w-44 text-sm text-gray-700 truncate",
                              title: n.label
                            }, _toDisplayString(n.label), 9, _hoisted_24),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["h-5 rounded-full", stageBarClass(n.statut)]),
                                style: _normalizeStyle({ width: barWidth(n.count, maxNiveau.value) })
                              }, null, 6)
                            ]),
                            _createElementVNode("div", _hoisted_26, _toDisplayString(n.count), 1),
                            _createElementVNode("div", {
                              class: "w-64 text-xs text-gray-400 truncate",
                              title: n.motif
                            }, _toDisplayString(n.motif), 9, _hoisted_27)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_28, "Aucune donnée."))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "font-semibold text-gray-800" }, "Détail des courriers en cours", -1)),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_unref(Search), { class: "w-4 h-4 text-gray-400 absolute left-2.5 top-1/2 -translate-y-1/2" }),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                          type: "text",
                          placeholder: "Rechercher (n°, objet, détenteur…)",
                          class: "pl-8 pr-3 py-1.5 border border-gray-300 rounded-lg text-sm w-64"
                        }, null, 512), [
                          [_vModelText, search.value]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(filteredDetail.value.length) + " résultat(s)", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("table", _hoisted_35, [
                      _cache[12] || (_cache[12] = _createElementVNode("thead", { class: "bg-gray-50 text-gray-500" }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "text-left px-4 py-2 font-medium" }, "Courrier"),
                          _createElementVNode("th", { class: "text-left px-4 py-2 font-medium" }, "Détenteur"),
                          _createElementVNode("th", { class: "text-left px-4 py-2 font-medium" }, "Direction / Ambassade"),
                          _createElementVNode("th", { class: "text-left px-4 py-2 font-medium" }, "Étape"),
                          _createElementVNode("th", { class: "text-right px-4 py-2 font-medium" }, "Depuis"),
                          _createElementVNode("th", { class: "text-left px-4 py-2 font-medium" }, "Pourquoi")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageRows.value, (r, i) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: i,
                            class: "border-t border-gray-100 hover:bg-gray-50/60"
                          }, [
                            _createElementVNode("td", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, "#" + _toDisplayString(r.courrier_id), 1),
                              (r.objet)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "text-xs text-gray-400 max-w-[220px] truncate",
                                    title: r.objet
                                  }, _toDisplayString(r.objet), 9, _hoisted_38))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_39, _toDisplayString(r.detenteur || '-'), 1),
                            _createElementVNode("td", _hoisted_40, _toDisplayString(r.direction || r.ambassade || '-'), 1),
                            _createElementVNode("td", _hoisted_41, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["px-2 py-0.5 rounded-full text-xs whitespace-nowrap", stagePillClass(r.statut)])
                              }, _toDisplayString(r.etape), 3)
                            ]),
                            _createElementVNode("td", {
                              class: _normalizeClass(["px-4 py-2 align-top text-right whitespace-nowrap", agingClass(r.depuis_jours)])
                            }, _toDisplayString(r.depuis_jours != null ? r.depuis_jours + ' j' : '-'), 3),
                            _createElementVNode("td", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0", stageDotClass(r.statut)])
                                }, null, 2),
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, _toDisplayString(r.motif || '-'), 1),
                                  (r.commentaire)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "text-xs text-gray-400 italic truncate",
                                        title: r.commentaire
                                      }, " « " + _toDisplayString(r.commentaire) + " » ", 9, _hoisted_46))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]))
                        }), 128)),
                        (!filteredDetail.value.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_47, _cache[11] || (_cache[11] = [
                              _createElementVNode("td", {
                                colspan: "6",
                                class: "px-4 py-8 text-center text-gray-400"
                              }, "Aucun courrier en cours.", -1)
                            ])))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  (totalPages.value > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (page.value = Math.max(1, page.value - 1))),
                          disabled: page.value === 1,
                          class: "px-3 py-1.5 rounded-lg border border-gray-300 disabled:opacity-40 hover:bg-gray-50"
                        }, "Précédent", 8, _hoisted_49),
                        _createElementVNode("span", _hoisted_50, "Page " + _toDisplayString(page.value) + " / " + _toDisplayString(totalPages.value), 1),
                        _createElementVNode("button", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (page.value = Math.min(totalPages.value, page.value + 1))),
                          disabled: page.value === totalPages.value,
                          class: "px-3 py-1.5 rounded-lg border border-gray-300 disabled:opacity-40 hover:bg-gray-50"
                        }, "Suivant", 8, _hoisted_51)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})